<span class="ml-3">
  <a target="_blank" href="{{helpUrl}}" [pTooltip]="helpLinkTooltipContent" tooltipPosition="top" aria-label="Get help for this page" escape="false" class="text-primary">
    <span class="pi pi-question-circle text-l"></span>
  </a>
</span>
<ng-template #helpLinkTooltipContent>
  <div class="flex align-items-left">
    Get help for this page.
  </div>
  <div class="flex align-items-left">
    This will open a new tab.
  </div>
</ng-template>
